import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *回复列表
 * @param params
 * 
*/

export const discussList = params => Http.get(`${baseUrl}/activity/discuss`, { params })

/**
 *修改
 * @param params 
 * 
*/

export const editDiscuss = params  => Http.put(`${baseUrl}/activity/discuss`, params )

/**
 *删除
 * @param discussId
 * 
*/

export const delDiscuss = discussId => Http.delete(`${baseUrl}/activity/discuss/${discussId }`)

/**
 *回复
 * @param params
 * 
*/

export const replyDiscuss = params => Http.post(`${baseUrl}/activity/discuss`,  params )

/**
 *点赞
 * @param discussId
 * 
*/

export const starDiscuss = discussId => Http.post(`${baseUrl}/activity/discuss/${discussId}/star`)

/**
 *取消点赞
 * @param discussId
 * 
*/

export const cancelStarDiscuss = discussId => Http.post(`${baseUrl}/activity/discuss/${discussId}/cancelStar`)

/**
 *置顶/取消置顶
 * @param discussId
 * 
*/

export const topDiscuss = discussId => Http.put(`${baseUrl}/activity/discuss/${discussId}/top`)
